import {BrowserRouter, Routes, Route} from 'react-router-dom'
import React, {useEffect} from 'react'
import {OrderDetailsComponent} from './screens/order-details'
// import {Home} from './screens/home'
import {PaymentDetailsComponent} from './screens/payment-details'
import {AppointmentDetailsComponent} from './screens/appointment-details'
import {AcknowledgementComponent} from './screens/acknowledgement'
import AuthForm from './components/AuthForm'
import NotFoundForm from './components/NotFoundForm'
import VerifyToken from './components/VerifyToken'
import {useDispatch} from 'react-redux'
import {mobileViewStatus} from './redux/screenViewSlice'
import {PaymentInformationProvider} from './components/keap-partner/payment-information-components/contexts/payment-information-provider'

export const PageRouter = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    const checkIfMobile = () => {
      dispatch(mobileViewStatus(window.innerWidth <= 768))
    }

    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)

    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/client-order" element={<OrderDetailsComponent />} />
        <Route
          path="/client-appointment"
          element={<AppointmentDetailsComponent />}
        />
        <Route
          path="/client-payment"
          element={
            <PaymentInformationProvider>
              <PaymentDetailsComponent />
            </PaymentInformationProvider>
          }
        />
        <Route path="/" element={<AuthForm />} />
        <Route path="/verifytoken" element={<VerifyToken />} />
        <Route path="/not-found" element={<NotFoundForm />} />
        <Route
          path="/client-acknowledgement"
          element={<AcknowledgementComponent />}
        />
      </Routes>
    </BrowserRouter>
  )
}
